import Helpers from "../base/Helpers";
import Flickity from "flickity";

const selectors = {
  upsellProduct: '[data-upsell-product]:not(.disabled)',
  upsellContainer: '.free_upsell-card-products',
  checkoutButton: 'button[name="checkout"]:not(disabled)',
  checkoutFreeShippingModal: '#shippingModal',
  checkoutGiftOneModal: '#giftOneModal',
  checkoutGiftTwoModal: '#giftTwoModal',
  productList: '.product-list'
};

function unregisterCart() {
  $(selectors.upsellProduct).off('click');
}
function registerCart() {
  // Register on click even to add upsell product
  registerAddToCart();
  // Check gifts in cart
  checkGiftsInCart();
  $(selectors.upsellContainer).removeClass('is-loading');

  registerCheckoutListener();
  // We clear the cart attributes when not on cart page since discount resets itself
  if ( window.routes.cartUrl !== window.location.pathname ){
    if ( !!window.theme.cartDiscount ){
      removeDiscount(false);
    }
  }
}

function triggerLoadingState() {
  $(selectors.upsellContainer).addClass('is-loading');
}
var _products = []
var _cart = []
var _selected_gifts = []
let giftsOneAdded = false
let giftsTwoAdded = false
let bothgiftsAdded = false
function getCartAndProducts(){
  $.getJSON('/cart.js').then(function(cart) {
    _cart = cart
    var product_calls = cart.items.map(function(item){
        return $.getJSON('/products/'+item.handle+'.js').then(function(product){
        product.variant_id = item.variant_id
        return product
        })
    })
    Promise.all(product_calls).then(function(products){
        products.forEach(function(product){
        _products.push(product)
        _selected_gifts[0] = product.tags.includes('__gift_first_threshold')?product.variant_id:_selected_gifts[0]
        _selected_gifts[1] = product.tags.includes('__gift_second_threshold')?product.variant_id:_selected_gifts[1]
          if (product.tags.includes('__gift_first_threshold')) {
            giftsOneAdded = true
          }
          if (product.tags.includes('__gift_second_threshold')) {
            giftsTwoAdded = true
          }
        })
    })
  })
}


function registerAddToCart(){
  $(selectors.upsellProduct).on('click', e => {
    const variantId = e.currentTarget.getAttribute('data-upsell-product');
    const alreadyInCart = e.currentTarget.getAttribute('data-in-cart');
    const giftStage = e.currentTarget.getAttribute('data-gift-stage');
    const giftLevel = e.currentTarget.getAttribute('data-gift-level');
    const giftThreshold = parseInt(e.currentTarget.getAttribute('data-gift-threshold'));

    if (alreadyInCart == 'true' && _selected_gifts[giftLevel] != variantId) {
      var updates = {}
      if (!!_selected_gifts[giftLevel]) {
        updates[_selected_gifts[giftLevel]] = 0
      }
      
      fetch(window.theme.localeRootUrl + '/cart/update.js', {
        body: JSON.stringify({updates: updates}),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(function(cart){return cart.json()})
      .then(function(json){
        addCartUpsell(variantId, giftStage, giftThreshold)
      }, function(error){
        console.log(error);
      })
    } else {
      if (alreadyInCart == 'false') {
        addCartUpsell(variantId, giftStage, giftThreshold)
      }else {
        removeCartUpsell(variantId)
      }
    }
  })
}
function checkGiftsInCart() {
  const scriptVariables = document.getElementById('cartVariables');
  if (!!!scriptVariables) {
    return
  }
  const variableJson = JSON.parse(scriptVariables.textContent);

  
  const giftOneVariant = variableJson.selected_gift_tier_1.toString();
  const giftOneCount = parseInt(variableJson.selected_gift_count_1);
  const giftOneKey = variableJson.selected_gift_key_1.toString();
  const giftTwoVariant = variableJson.selected_gift_tier_2.toString();
  const giftTwoCount = parseInt(variableJson.selected_gift_count_2);
  const giftTwoKey = variableJson.selected_gift_key_2.toString();
  const giftTotalCount = parseInt(variableJson.total_gift_counter);
  const giftOneAvailable = variableJson.gift_tier_one_reached;
  const giftTwoAvailable = variableJson.gift_tier_two_reached;

  // If there's more than 1 gift one selected, remove it
  if ( giftOneCount > 1 && giftOneVariant != "false" ) {
    removeCartUpsell(giftOneKey)
  }
  // If there's more than 1 gift two selected, remove it
  if ( giftTwoCount > 1 && giftTwoVariant != "false" ) {
    triggerLoadingState()
    removeCartUpsell(giftTwoKey)
  }

  // If there's more than 1 total gifts but gift 2 isn't selected. Remove gift 1
  if ( giftTotalCount > 1 && giftTwoCount == 0 && giftOneVariant != "false") {
    triggerLoadingState()
    removeCartUpsell(giftOneKey)
  } else if ( giftTotalCount > 2 && giftOneCount > 0 && giftTwoCount > 0 && giftTwoVariant != "false" ) {
    //If theres more than 2 gifts, and both gift 1 and 2 are selected. Remove gift 2
    triggerLoadingState()
    removeCartUpsell(giftTwoKey)
  }

  // If tier 1 isn't reached and gift 1 exists, remove it
  if ( giftOneAvailable == false && giftOneVariant != "false") {
    triggerLoadingState()
    removeCartUpsell(giftOneKey)
  }
  // If tier 2 isn't reached and gift 2 exists, remove it
  if ( giftTwoAvailable == false && giftTwoVariant != "false") {
    triggerLoadingState()
    removeCartUpsell(giftTwoKey)
  }

  // If both gifts are reached and in cart remove first
  if (window.theme.addBothGifts === false ) {
    if (giftOneAvailable == true && giftTwoAvailable == true) {
      $.getJSON('/cart.js').then(function(cart) {
        let giftsAddedArr = []
        cart.items.forEach(item=>{
          if (!!item.properties.__gift_stage_id) {
            giftsAddedArr.push(item.properties.__gift_stage_id)
          }
        })
        if (!!giftsAddedArr) {
          if (giftsAddedArr.length > 1) {
            triggerLoadingState()
            removeCartUpsell(giftsAddedArr[1])
          }
        }
      })
    }
  }
}

function addCartUpsell(variantId, giftStage, giftThreshold) {
  let formData = {
    items: [{
      id: variantId,
      quantity: 1,
      properties: {
        '__gift_stage': giftStage,
        '__gift_stage_id': variantId,
        '__gift_threshold': giftThreshold
      }
    }],
  };
  triggerLoadingState()
  // Add items via helpers file
  Helpers.addCartItems(formData).then((response) => {
    if (response.status === 200) {
      window.location.reload();
      window.scrollTo(0, 0);
    }
  });
}

function removeCartUpsell(variantId) {
  Helpers.removeCartItem(variantId).then((response) => {
    if (response.status === 200) {
      window.location.reload();
    }
  });
}

function evaluatedDiscount(payload){
  if (payload.valid === true && !!!payload.cart.attributes.discount_code || discountedAmount != payload.discount ) {
    // code, discount amount, discounted subtotal
    Helpers.setCookie("discount_code", payload.discount_code, 365);
    Helpers.updateCartAttributes(payload.discountCode, payload.discount, payload.subtotal, true)
  } else {
    // $('.cart-skeleton-container').removeClass('is-loading')
  }
}

function removeDiscount(refresh){
  triggerLoadingState()
  Helpers.updateCartAttributes("", "", "", refresh)
}

function registerCheckoutListener() {
  // Handle modals
  $(selectors.checkoutButton).on("click", modalEventListener);
  
}

function modalEventListener(e) {
  const checkoutShippingSession = sessionStorage.getItem("checkout-modal-shipping");
  const checkoutGiftOneSession = sessionStorage.getItem("checkout-modal-gift-one");
  const checkoutGiftTwoSession = sessionStorage.getItem("checkout-modal-gift-two");

  const shippingModal = $(selectors.checkoutFreeShippingModal)
  const giftOneModal = $(selectors.checkoutGiftOneModal)
  const giftTwoModal = $(selectors.checkoutGiftTwoModal)

  if ( !!!checkoutShippingSession && !!shippingModal.length ) {
    e.preventDefault();
    triggerCheckoutModal(selectors.checkoutFreeShippingModal, "checkout-modal-shipping")
  }
  if ( !!!checkoutGiftOneSession && !!giftOneModal.length ) {
    e.preventDefault();
    triggerCheckoutModal(selectors.checkoutGiftOneModal, "checkout-modal-gift-one");
  }
  if ( !!!checkoutGiftTwoSession && !!giftTwoModal.length ) {
    e.preventDefault();
    triggerCheckoutModal(selectors.checkoutGiftTwoModal, "checkout-modal-gift-two");
  }
}

function triggerCheckoutModal(modalElement, sessionItem){
  
  const modal = $(modalElement);
  // If modal exists, we open it. Whether it exists is handled by liquid
  if( !!modal.length ){
      modal.attr("aria-hidden", false)
      modal.find('[data-action="close-modal"]').on("click", e => {
        modal.attr("aria-hidden", true)
    })
    // Check if we click outside the modal
    $(document.body).on('click', e => {
      if($(e.target).is(modal)){
        modal.attr("aria-hidden", true)
        $(document.body).off('click');
      }
    });
  }
  sessionStorage.setItem(sessionItem, true)

}

document.addEventListener("DOMContentLoaded", function () {
  registerCart();
  getCartAndProducts()
});

window.addEventListener('discountz', (event) => {
  if (!(event instanceof CustomEvent)) return;

  switch (event.detail.type) {
    case 'discount-cleared':
      // handle Discount Cleared event
      console.log('cleared', event)
      removeDiscount(true);
      break;

    case 'discount-submitted':
      // handle Discount Submitted event
      console.log('submitted', event)
      // $('.cart-skeleton-container').addClass('is-loading')
      break;

    case 'discount-evaluated':
      // handle Discount Evaluated event
      console.log('evaluated', event.detail.payload);
      evaluatedDiscount(event.detail.payload);
      break;
  }
});

function initFlickity(element) {
  const flickity = new Flickity( element, {
    watchCSS: true,
    pageDots: false,
    prevNextButtons: true,
    contain: true,
    resize: false,
    groupCells: true,
    cellAlign: 'left',
    draggable: !window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches
  });

  let lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth !== lastWidth) {
      flickity.resize();
      lastWidth = window.innerWidth;
    }
  });
}

document.addEventListener('cart:rerendered', function(){
  unregisterCart();
  registerCart();
  getCartAndProducts()

  const productLists = document.querySelectorAll(selectors.productList);
  productLists.forEach((list) => {
    initFlickity(list);
  });
});



// this code for add email_consent attribte as "False" from the cart 
var $element = $('.cart-recap');
var inputHtmlEmail = `<input type="hidden" data-backup="email_consent" name="attributes[email_consent]" value="false">`;
if(!!$element){
  $element.append(inputHtmlEmail);
}

